import {
    Button,
    CircularProgress,
  } from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import ResponsiveDrawer from "../../components/ClippedResponsiveDrawer";
import { AxiosRequestConfig } from "axios";
import { useEffect, useState } from "react";
import { AXIOS_INSTANCE, BASE_URL } from "../../App";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import TableAbstraction from "../../componentUtils/TableAbstraction"
import VmMatTypeHeader from "./VmMatTypeHeader";

interface ReportState {
  data: ReportRow[],
  isLoaded: boolean,
  isLoading: boolean,
}
interface ReportRow {
  client_id: number;
  sales_org: string;
  sales_office: string;
  customer_num: string;
  equipment_num: string;
  bottle: number;
  can: number;
  unknown: number;
  machine_type: string;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root:{},
    typography: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
  })
);


async function getReportData(salesOrg: string, deliveringPlants: string[],active:any) {
  const configReporting: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    data: {
      "deliveringPlants": JSON.stringify(deliveringPlants),
      "customerStatus": active,
    },
    url: `${BASE_URL}/api/reporting/vm/mat/type`,
  };

  return await AXIOS_INSTANCE(configReporting).then((res: any) => res.data);
}

export default function VmMatTypeReport() {
  const classes = useStyles();
  const [state, setState] = useState<ReportState>({
    data: [],
    isLoaded: false,
    isLoading: false,
  });
  const [ReportData, SetReportData] = useState<any[]>([]);
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const sOrg = salesOrg.toString();
  const active = 1;

const onSelectionChange = (deliveringPlants: string[], active:any) => {
 // console.log('selection')
 
  const sOrg = salesOrg.toString();
  //if (salesOffices.length > 0) {
    setState({...state, isLoading: true});
    getReportData(sOrg, deliveringPlants,active)
    .then((v) => {
      setState({isLoaded: true, isLoading: false, data:v});
    })
  //}
}
   
    return (
        <ResponsiveDrawer
        title="VM Material Type"
      >
          <div className={classes.root}>
          <VmMatTypeHeader onSelectionChange={onSelectionChange} />
          {state.isLoading &&
              <CircularProgress />
          }
          {!state.isLoading &&
              <TableAbstraction
              settingsKey="RPT_MTR"
                      options={{
                        serverSide: false,
                        responsive: "vertical",
                        selectableRows: "none",
                        rowsPerPage: 100,
                        tableHeightReducePx: 60,
                        sortOrder: [{ name: "customerNum", direction: "asc" }],
                      }}
                      title="Vending Machine Reports"
                      columns={[
                        {
                          label: "Client Id",
                          name: "client_id",
                        },
                        {
                          label: "Sales Org #",
                          name: "sales_org",
                        },
                        {
                          label: "Sales Office",
                          name: "sales_office",
                        },
                        {
                          label: "Delivery Plant",
                          name: "delivering_plant",
                        },
                        {
                          label: "Customer Number",
                          name: "customer_num",
                        },  
                        {
                          label: "Equipment Number",
                          name: "equipment_num",
                        },  
                        {
                          label: "Bottle",
                          name: "bottle",
                        }, 
                        {
                          label: "Can",
                          name: "can",
                        },
                        {
                          label: "Unknown",
                          name: "unknown",
                        },  
                        {
                          label: "Machine Type",
                          name: "machine_type",
                        },  
                                                                 
                      ]}
                      data={state.data}
                    /> 
            }

        </div>
    </ResponsiveDrawer>

    );
}